export default __webpack_public_path__ + "static/media/2.8a268240.jpg";